export function suggestions() {
    return [
        ...getParameterDef(),
        ...getLogDef(),
        ...getVariableDef(),
        ...getProgramStarts(),
        ...getCustom()
    ];
}
function getParameterDef() {
    return [...getInputParameterDef(), ...getOutputParameterDef()];
}
function getOutputParameterDef() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    return [{
            'label': `OPCH`,
            'kind': (_a = window.monaco) === null || _a === void 0 ? void 0 : _a.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as char\n        no-undo.`,
            'insertTextRules': (_b = window.monaco) === null || _b === void 0 ? void 0 : _b.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Character OUTPUT parameter`
        },
        {
            'label': `OPCM`,
            'kind': (_c = window.monaco) === null || _c === void 0 ? void 0 : _c.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as\n        com-handle no-undo.`,
            'insertTextRules': (_d = window.monaco) === null || _d === void 0 ? void 0 : _d.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Com-handle OUTPUT parameter`
        },
        {
            'label': `OPDE`,
            'kind': (_e = window.monaco) === null || _e === void 0 ? void 0 : _e.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as dec\n        no-undo.`,
            'insertTextRules': (_f = window.monaco) === null || _f === void 0 ? void 0 : _f.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Decimal OUTPUT parameter`
        },
        {
            'label': `OPDM`,
            'kind': (_g = window.monaco) === null || _g === void 0 ? void 0 : _g.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as datetime\n        no-undo.`,
            'insertTextRules': (_h = window.monaco) === null || _h === void 0 ? void 0 : _h.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime OUTPUT parameter`
        },
        {
            'label': `OPDT`,
            'kind': (_j = window.monaco) === null || _j === void 0 ? void 0 : _j.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as date\n        no-undo.`,
            'insertTextRules': (_k = window.monaco) === null || _k === void 0 ? void 0 : _k.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Date OUTPUT parameter`
        },
        {
            'label': `OPDTZ`,
            'kind': (_l = window.monaco) === null || _l === void 0 ? void 0 : _l.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as\n        datetime-tz no-undo.`,
            'insertTextRules': (_m = window.monaco) === null || _m === void 0 ? void 0 : _m.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime-tz OUTPUT parameter`
        },
        {
            'label': `OPHN`,
            'kind': (_o = window.monaco) === null || _o === void 0 ? void 0 : _o.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as handle\n        no-undo.`,
            'insertTextRules': (_p = window.monaco) === null || _p === void 0 ? void 0 : _p.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Handle OUTPUT parameter`
        },
        {
            'label': `OPI6`,
            'kind': (_q = window.monaco) === null || _q === void 0 ? void 0 : _q.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as int64 no-undo.`,
            'insertTextRules': (_r = window.monaco) === null || _r === void 0 ? void 0 : _r.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Int64 OUTPUT parameter`
        },
        {
            'label': `OPIN`,
            'kind': (_s = window.monaco) === null || _s === void 0 ? void 0 : _s.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as int\n        no-undo.`,
            'insertTextRules': (_t = window.monaco) === null || _t === void 0 ? void 0 : _t.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Integer OUTPUT parameter`
        },
        {
            'label': `OPLC`,
            'kind': (_u = window.monaco) === null || _u === void 0 ? void 0 : _u.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as longchar\n        no-undo.`,
            'insertTextRules': (_v = window.monaco) === null || _v === void 0 ? void 0 : _v.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Longchar OUTPUT parameter`
        },
        {
            'label': `OPLG`,
            'kind': (_w = window.monaco) === null || _w === void 0 ? void 0 : _w.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as logical\n        no-undo.`,
            'insertTextRules': (_x = window.monaco) === null || _x === void 0 ? void 0 : _x.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Logical OUTPUT parameter`
        },
        {
            'label': `OPMP`,
            'kind': (_y = window.monaco) === null || _y === void 0 ? void 0 : _y.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as memptr\n        no-undo.`,
            'insertTextRules': (_z = window.monaco) === null || _z === void 0 ? void 0 : _z.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Memptr OUTPUT parameter`
        },
        {
            'label': `OPR`,
            'kind': (_0 = window.monaco) === null || _0 === void 0 ? void 0 : _0.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as raw no-undo.`,
            'insertTextRules': (_1 = window.monaco) === null || _1 === void 0 ? void 0 : _1.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Raw OUTPUT parameter`
        },
        {
            'label': `OPRC`,
            'kind': (_2 = window.monaco) === null || _2 === void 0 ? void 0 : _2.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as recid no-undo.`,
            'insertTextRules': (_3 = window.monaco) === null || _3 === void 0 ? void 0 : _3.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Recid OUTPUT parameter`
        },
        {
            'label': `OPRI`,
            'kind': (_4 = window.monaco) === null || _4 === void 0 ? void 0 : _4.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as rowid\n        no-undo.`,
            'insertTextRules': (_5 = window.monaco) === null || _5 === void 0 ? void 0 : _5.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `ROWID OUTPUT parameter`
        },
        {
            'label': `OPWH`,
            'kind': (_6 = window.monaco) === null || _6 === void 0 ? void 0 : _6.languages.CompletionItemKind.Variable,
            'insertText': `def output param $1 as\n        widget-handle no-undo.`,
            'insertTextRules': (_7 = window.monaco) === null || _7 === void 0 ? void 0 : _7.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Widget OUTPUT parameter`
        },];
}
function getInputParameterDef() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39;
    return [{
            'label': `IOPCH`,
            'kind': (_a = window.monaco) === null || _a === void 0 ? void 0 : _a.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        char no-undo.`,
            'insertTextRules': (_b = window.monaco) === null || _b === void 0 ? void 0 : _b.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Character INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPCM`,
            'kind': (_c = window.monaco) === null || _c === void 0 ? void 0 : _c.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        com-handle no-undo.`,
            'insertTextRules': (_d = window.monaco) === null || _d === void 0 ? void 0 : _d.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Com-handle INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPDE`,
            'kind': (_e = window.monaco) === null || _e === void 0 ? void 0 : _e.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        dec no-undo.`,
            'insertTextRules': (_f = window.monaco) === null || _f === void 0 ? void 0 : _f.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Decimal INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPDM`,
            'kind': (_g = window.monaco) === null || _g === void 0 ? void 0 : _g.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        datetime no-undo.`,
            'insertTextRules': (_h = window.monaco) === null || _h === void 0 ? void 0 : _h.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPDT`,
            'kind': (_j = window.monaco) === null || _j === void 0 ? void 0 : _j.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        date no-undo.`,
            'insertTextRules': (_k = window.monaco) === null || _k === void 0 ? void 0 : _k.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Date INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPDTZ`,
            'kind': (_l = window.monaco) === null || _l === void 0 ? void 0 : _l.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        datetime-tz no-undo.`,
            'insertTextRules': (_m = window.monaco) === null || _m === void 0 ? void 0 : _m.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime-tz INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPHN`,
            'kind': (_o = window.monaco) === null || _o === void 0 ? void 0 : _o.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        handle no-undo.`,
            'insertTextRules': (_p = window.monaco) === null || _p === void 0 ? void 0 : _p.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Handle INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPI6`,
            'kind': (_q = window.monaco) === null || _q === void 0 ? void 0 : _q.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        int64 no-undo.`,
            'insertTextRules': (_r = window.monaco) === null || _r === void 0 ? void 0 : _r.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Int64 INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPIN`,
            'kind': (_s = window.monaco) === null || _s === void 0 ? void 0 : _s.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        int no-undo.`,
            'insertTextRules': (_t = window.monaco) === null || _t === void 0 ? void 0 : _t.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Integer INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPLG`,
            'kind': (_u = window.monaco) === null || _u === void 0 ? void 0 : _u.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        logical no-undo.`,
            'insertTextRules': (_v = window.monaco) === null || _v === void 0 ? void 0 : _v.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Logical INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPMP`,
            'kind': (_w = window.monaco) === null || _w === void 0 ? void 0 : _w.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        memptr no-undo.`,
            'insertTextRules': (_x = window.monaco) === null || _x === void 0 ? void 0 : _x.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Memptr INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPR`,
            'kind': (_y = window.monaco) === null || _y === void 0 ? void 0 : _y.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        raw no-undo.`,
            'insertTextRules': (_z = window.monaco) === null || _z === void 0 ? void 0 : _z.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Raw INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPRC`,
            'kind': (_0 = window.monaco) === null || _0 === void 0 ? void 0 : _0.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        recid no-undo.`,
            'insertTextRules': (_1 = window.monaco) === null || _1 === void 0 ? void 0 : _1.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Recid INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPRI`,
            'kind': (_2 = window.monaco) === null || _2 === void 0 ? void 0 : _2.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        rowid no-undo.`,
            'insertTextRules': (_3 = window.monaco) === null || _3 === void 0 ? void 0 : _3.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `ROWID INPUT-OUTPUT parameter`
        },
        {
            'label': `IOPWH`,
            'kind': (_4 = window.monaco) === null || _4 === void 0 ? void 0 : _4.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        widget no-undo.`,
            'insertTextRules': (_5 = window.monaco) === null || _5 === void 0 ? void 0 : _5.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Widget INPUT-OUTPUT parameter`
        },
        {
            'label': `IPCH`,
            'kind': (_6 = window.monaco) === null || _6 === void 0 ? void 0 : _6.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as char\n        no-undo.`,
            'insertTextRules': (_7 = window.monaco) === null || _7 === void 0 ? void 0 : _7.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Character INPUT parameter`
        },
        {
            'label': `IPCLC`,
            'kind': (_8 = window.monaco) === null || _8 === void 0 ? void 0 : _8.languages.CompletionItemKind.Variable,
            'insertText': `def input-output param $1 as\n        longchar no-undo.`,
            'insertTextRules': (_9 = window.monaco) === null || _9 === void 0 ? void 0 : _9.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Longchar INPUT-OUTPUT parameter`
        },
        {
            'label': `IPCM`,
            'kind': (_10 = window.monaco) === null || _10 === void 0 ? void 0 : _10.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as com-handle\n        no-undo.`,
            'insertTextRules': (_11 = window.monaco) === null || _11 === void 0 ? void 0 : _11.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Com-handle INPUT parameter`
        },
        {
            'label': `IPDE`,
            'kind': (_12 = window.monaco) === null || _12 === void 0 ? void 0 : _12.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as dec\n        no-undo.`,
            'insertTextRules': (_13 = window.monaco) === null || _13 === void 0 ? void 0 : _13.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Decimal INPUT parameter`
        },
        {
            'label': `IPDM`,
            'kind': (_14 = window.monaco) === null || _14 === void 0 ? void 0 : _14.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as datetime\n        no-undo.`,
            'insertTextRules': (_15 = window.monaco) === null || _15 === void 0 ? void 0 : _15.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime INPUT parameter`
        },
        {
            'label': `IPDT`,
            'kind': (_16 = window.monaco) === null || _16 === void 0 ? void 0 : _16.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as date no-undo.`,
            'insertTextRules': (_17 = window.monaco) === null || _17 === void 0 ? void 0 : _17.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Date INPUT parameter`
        },
        {
            'label': `IPDTZ`,
            'kind': (_18 = window.monaco) === null || _18 === void 0 ? void 0 : _18.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as\n        datetime-tz no-undo.`,
            'insertTextRules': (_19 = window.monaco) === null || _19 === void 0 ? void 0 : _19.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime-tz INPUT parameter`
        },
        {
            'label': `IPHN`,
            'kind': (_20 = window.monaco) === null || _20 === void 0 ? void 0 : _20.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as handle\n        no-undo.`,
            'insertTextRules': (_21 = window.monaco) === null || _21 === void 0 ? void 0 : _21.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Handle INPUT parameter`
        },
        {
            'label': `IPI6`,
            'kind': (_22 = window.monaco) === null || _22 === void 0 ? void 0 : _22.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as int64 no-undo.`,
            'insertTextRules': (_23 = window.monaco) === null || _23 === void 0 ? void 0 : _23.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Int64 INPUT parameter`
        },
        {
            'label': `IPIN`,
            'kind': (_24 = window.monaco) === null || _24 === void 0 ? void 0 : _24.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as int\n        no-undo.`,
            'insertTextRules': (_25 = window.monaco) === null || _25 === void 0 ? void 0 : _25.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Integer INPUT parameter`
        },
        {
            'label': `IPLC`,
            'kind': (_26 = window.monaco) === null || _26 === void 0 ? void 0 : _26.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as longchar\n        no-undo.`,
            'insertTextRules': (_27 = window.monaco) === null || _27 === void 0 ? void 0 : _27.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Longchar INPUT parameter`
        },
        {
            'label': `IPLG`,
            'kind': (_28 = window.monaco) === null || _28 === void 0 ? void 0 : _28.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as logical\n        no-undo.`,
            'insertTextRules': (_29 = window.monaco) === null || _29 === void 0 ? void 0 : _29.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Logical INPUT parameter`
        },
        {
            'label': `IPMP`,
            'kind': (_30 = window.monaco) === null || _30 === void 0 ? void 0 : _30.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as memptr\n        no-undo.`,
            'insertTextRules': (_31 = window.monaco) === null || _31 === void 0 ? void 0 : _31.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Memptr INPUT parameter`
        },
        {
            'label': `IPR`,
            'kind': (_32 = window.monaco) === null || _32 === void 0 ? void 0 : _32.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as raw no-undo.`,
            'insertTextRules': (_33 = window.monaco) === null || _33 === void 0 ? void 0 : _33.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Raw INPUT parameter`
        },
        {
            'label': `IPRC`,
            'kind': (_34 = window.monaco) === null || _34 === void 0 ? void 0 : _34.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as recid no-undo.`,
            'insertTextRules': (_35 = window.monaco) === null || _35 === void 0 ? void 0 : _35.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Recid INPUT parameter`
        },
        {
            'label': `IPRI`,
            'kind': (_36 = window.monaco) === null || _36 === void 0 ? void 0 : _36.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as rowid\n        no-undo.`,
            'insertTextRules': (_37 = window.monaco) === null || _37 === void 0 ? void 0 : _37.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `ROWID INPUT parameter`
        },
        {
            'label': `IPWH`,
            'kind': (_38 = window.monaco) === null || _38 === void 0 ? void 0 : _38.languages.CompletionItemKind.Variable,
            'insertText': `def input param $1 as widget\n        no-undo.`,
            'insertTextRules': (_39 = window.monaco) === null || _39 === void 0 ? void 0 : _39.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Widget INPUT parameter`
        },];
}
function getVariableDef() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43;
    return [{
            'label': `DSVCH`,
            'kind': (_a = window.monaco) === null || _a === void 0 ? void 0 : _a.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as char\n        no-undo.`,
            'insertTextRules': (_b = window.monaco) === null || _b === void 0 ? void 0 : _b.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Character variable`
        },
        {
            'label': `DSVCL`,
            'kind': (_c = window.monaco) === null || _c === void 0 ? void 0 : _c.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as\n        Progress.Lang.Object no-undo.`,
            'insertTextRules': (_d = window.monaco) === null || _d === void 0 ? void 0 : _d.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Class variable`
        },
        {
            'label': `DSVCM`,
            'kind': (_e = window.monaco) === null || _e === void 0 ? void 0 : _e.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as\n        com-handle no-undo.`,
            'insertTextRules': (_f = window.monaco) === null || _f === void 0 ? void 0 : _f.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Com-handle variable`
        },
        {
            'label': `DSVDE`,
            'kind': (_g = window.monaco) === null || _g === void 0 ? void 0 : _g.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as dec\n        no-undo.`,
            'insertTextRules': (_h = window.monaco) === null || _h === void 0 ? void 0 : _h.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Decimal variable`
        },
        {
            'label': `DSVDM`,
            'kind': (_j = window.monaco) === null || _j === void 0 ? void 0 : _j.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as datetime\n        no-undo.`,
            'insertTextRules': (_k = window.monaco) === null || _k === void 0 ? void 0 : _k.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Datetime variable`
        },
        {
            'label': `DSVDT`,
            'kind': (_l = window.monaco) === null || _l === void 0 ? void 0 : _l.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as date\n        no-undo.`,
            'insertTextRules': (_m = window.monaco) === null || _m === void 0 ? void 0 : _m.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Date variable`
        },
        {
            'label': `DSVDTZ`,
            'kind': (_o = window.monaco) === null || _o === void 0 ? void 0 : _o.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as\n        datetime-tz no-undo.`,
            'insertTextRules': (_p = window.monaco) === null || _p === void 0 ? void 0 : _p.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Datetime-tz variable`
        },
        {
            'label': `DSVHN`,
            'kind': (_q = window.monaco) === null || _q === void 0 ? void 0 : _q.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as handle\n        no-undo.`,
            'insertTextRules': (_r = window.monaco) === null || _r === void 0 ? void 0 : _r.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Handle variable`
        },
        {
            'label': `DSVI6`,
            'kind': (_s = window.monaco) === null || _s === void 0 ? void 0 : _s.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as int6window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet no-undo.`,
            'insertTextRules': (_t = window.monaco) === null || _t === void 0 ? void 0 : _t.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Int6window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet variable`
        },
        {
            'label': `DSVIN`,
            'kind': (_u = window.monaco) === null || _u === void 0 ? void 0 : _u.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as int\n        no-undo.`,
            'insertTextRules': (_v = window.monaco) === null || _v === void 0 ? void 0 : _v.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Integer variable`
        },
        {
            'label': `DSVLC`,
            'kind': (_w = window.monaco) === null || _w === void 0 ? void 0 : _w.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as longchar\n        no-undo.`,
            'insertTextRules': (_x = window.monaco) === null || _x === void 0 ? void 0 : _x.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Longchar variable`
        },
        {
            'label': `DSVLG`,
            'kind': (_y = window.monaco) === null || _y === void 0 ? void 0 : _y.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as logical\n        no-undo.`,
            'insertTextRules': (_z = window.monaco) === null || _z === void 0 ? void 0 : _z.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Logical variable`
        },
        {
            'label': `DSVMP`,
            'kind': (_0 = window.monaco) === null || _0 === void 0 ? void 0 : _0.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as memptr\n        no-undo.`,
            'insertTextRules': (_1 = window.monaco) === null || _1 === void 0 ? void 0 : _1.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Mem Pointer variable`
        },
        {
            'label': `DSVR`,
            'kind': (_2 = window.monaco) === null || _2 === void 0 ? void 0 : _2.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as raw no-undo.`,
            'insertTextRules': (_3 = window.monaco) === null || _3 === void 0 ? void 0 : _3.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Raw variable`
        },
        {
            'label': `DSVRC`,
            'kind': (_4 = window.monaco) === null || _4 === void 0 ? void 0 : _4.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as recid no-undo.`,
            'insertTextRules': (_5 = window.monaco) === null || _5 === void 0 ? void 0 : _5.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Recid variable`
        },
        {
            'label': `DSVRI`,
            'kind': (_6 = window.monaco) === null || _6 === void 0 ? void 0 : _6.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as rowid\n        no-undo.`,
            'insertTextRules': (_7 = window.monaco) === null || _7 === void 0 ? void 0 : _7.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static ROWID variable`
        },
        {
            'label': `DSVWH`,
            'kind': (_8 = window.monaco) === null || _8 === void 0 ? void 0 : _8.languages.CompletionItemKind.Variable,
            'insertText': `def static var $1 as\n        widget-handle no-undo.`,
            'insertTextRules': (_9 = window.monaco) === null || _9 === void 0 ? void 0 : _9.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Static Widget variable`
        },
        {
            'label': `DVCH`,
            'kind': (_10 = window.monaco) === null || _10 === void 0 ? void 0 : _10.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as char no-undo.`,
            'insertTextRules': (_11 = window.monaco) === null || _11 === void 0 ? void 0 : _11.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Character variable`
        },
        {
            'label': `DVCL`,
            'kind': (_12 = window.monaco) === null || _12 === void 0 ? void 0 : _12.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as Progress.Lang.Object no-undo.`,
            'insertTextRules': (_13 = window.monaco) === null || _13 === void 0 ? void 0 : _13.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Class variable`
        },
        {
            'label': `DVCM`,
            'kind': (_14 = window.monaco) === null || _14 === void 0 ? void 0 : _14.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as com-handle no-undo.`,
            'insertTextRules': (_15 = window.monaco) === null || _15 === void 0 ? void 0 : _15.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Com-handle variable`
        },
        {
            'label': `DVDE`,
            'kind': (_16 = window.monaco) === null || _16 === void 0 ? void 0 : _16.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as dec no-undo.`,
            'insertTextRules': (_17 = window.monaco) === null || _17 === void 0 ? void 0 : _17.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Decimal variable`
        },
        {
            'label': `DVDM`,
            'kind': (_18 = window.monaco) === null || _18 === void 0 ? void 0 : _18.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as datetime no-undo.`,
            'insertTextRules': (_19 = window.monaco) === null || _19 === void 0 ? void 0 : _19.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime variable`
        },
        {
            'label': `DVDT`,
            'kind': (_20 = window.monaco) === null || _20 === void 0 ? void 0 : _20.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as date no-undo.`,
            'insertTextRules': (_21 = window.monaco) === null || _21 === void 0 ? void 0 : _21.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Date variable`
        },
        {
            'label': `DVDTZ`,
            'kind': (_22 = window.monaco) === null || _22 === void 0 ? void 0 : _22.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as datetime-tz no-undo.`,
            'insertTextRules': (_23 = window.monaco) === null || _23 === void 0 ? void 0 : _23.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Datetime-tz variable`
        },
        {
            'label': `DVHN`,
            'kind': (_24 = window.monaco) === null || _24 === void 0 ? void 0 : _24.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as handle no-undo.`,
            'insertTextRules': (_25 = window.monaco) === null || _25 === void 0 ? void 0 : _25.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Handle variable`
        },
        {
            'label': `DVI6`,
            'kind': (_26 = window.monaco) === null || _26 === void 0 ? void 0 : _26.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as int6window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet no-undo.`,
            'insertTextRules': (_27 = window.monaco) === null || _27 === void 0 ? void 0 : _27.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Int6window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet variable`
        },
        {
            'label': `DVIN`,
            'kind': (_28 = window.monaco) === null || _28 === void 0 ? void 0 : _28.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as int no-undo.`,
            'insertTextRules': (_29 = window.monaco) === null || _29 === void 0 ? void 0 : _29.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Integer variable`
        },
        {
            'label': `DVLC`,
            'kind': (_30 = window.monaco) === null || _30 === void 0 ? void 0 : _30.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as longchar no-undo.`,
            'insertTextRules': (_31 = window.monaco) === null || _31 === void 0 ? void 0 : _31.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Longchar variable`
        },
        {
            'label': `DVLG`,
            'kind': (_32 = window.monaco) === null || _32 === void 0 ? void 0 : _32.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as logical no-undo.`,
            'insertTextRules': (_33 = window.monaco) === null || _33 === void 0 ? void 0 : _33.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Logical variable`
        },
        {
            'label': `DVMP`,
            'kind': (_34 = window.monaco) === null || _34 === void 0 ? void 0 : _34.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as memptr no-undo.`,
            'insertTextRules': (_35 = window.monaco) === null || _35 === void 0 ? void 0 : _35.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Mem Pointer variable`
        },
        {
            'label': `DVR`,
            'kind': (_36 = window.monaco) === null || _36 === void 0 ? void 0 : _36.languages.CompletionItemKind.Variable,
            'insertText': `def\n        var $1 as raw no-undo.`,
            'insertTextRules': (_37 = window.monaco) === null || _37 === void 0 ? void 0 : _37.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Raw variable`
        },
        {
            'label': `DVRC`,
            'kind': (_38 = window.monaco) === null || _38 === void 0 ? void 0 : _38.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as recid no-undo.`,
            'insertTextRules': (_39 = window.monaco) === null || _39 === void 0 ? void 0 : _39.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Recid variable`
        },
        {
            'label': `DVRI`,
            'kind': (_40 = window.monaco) === null || _40 === void 0 ? void 0 : _40.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as rowid no-undo.`,
            'insertTextRules': (_41 = window.monaco) === null || _41 === void 0 ? void 0 : _41.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `ROWID variable`
        },
        {
            'label': `DVWH`,
            'kind': (_42 = window.monaco) === null || _42 === void 0 ? void 0 : _42.languages.CompletionItemKind.Variable,
            'insertText': `def var $1 as widget-handle no-undo.`,
            'insertTextRules': (_43 = window.monaco) === null || _43 === void 0 ? void 0 : _43.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Widget variable`
        },];
}
function getLogDef() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    return [
        //     'label': `jErr`,
        //     'kind': window.monaco?.languages.CompletionItemKind.Variable,
        //     'insertText': `run jErr('${msgHash}', '${field}',\n        '${message}', '${params}').`,
        //     'insertTextRules': window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        //     'documentation': `Create jErr line`
        // },
        // {
        //     'label': `jMsg`,
        //     'kind': window.monaco?.languages.CompletionItemKind.Snippet,
        //     'insertText': `run jMsg('${msgHash}',\n        '${message}', '${params}', '${title}', '${buttons}', ${timeOut}).`,
        //     'insertTextRules': window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        //     'documentation': `Create jMsg line`
        // },
        {
            'label': `devLog`,
            'kind': (_a = window.monaco) === null || _a === void 0 ? void 0 : _a.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=${'5'} &LogTxt=\`'DEVERROR:${(_c = (_b = window.PIC) === null || _b === void 0 ? void 0 : _b.user) !== null && _c !== void 0 ? _c : '$0'} '$1\`}`,
            'insertTextRules': (_d = window.monaco) === null || _d === void 0 ? void 0 : _d.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create developer error log line`
        },
        {
            'label': `log`,
            'kind': (_e = window.monaco) === null || _e === void 0 ? void 0 : _e.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=5 &LogTxt=\`$1\`}`,
            'insertTextRules': (_f = window.monaco) === null || _f === void 0 ? void 0 : _f.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line`
        },
        {
            'label': `log0`,
            'kind': (_g = window.monaco) === null || _g === void 0 ? void 0 : _g.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=0 &LogTxt=\`$1\`}`,
            'insertTextRules': (_h = window.monaco) === null || _h === void 0 ? void 0 : _h.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 0`
        },
        {
            'label': `log1`,
            'kind': (_j = window.monaco) === null || _j === void 0 ? void 0 : _j.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=1 &LogTxt=\`$1\`}`,
            'insertTextRules': (_k = window.monaco) === null || _k === void 0 ? void 0 : _k.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 1`
        },
        {
            'label': `log2`,
            'kind': (_l = window.monaco) === null || _l === void 0 ? void 0 : _l.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=2 &LogTxt=\`$1\`}`,
            'insertTextRules': (_m = window.monaco) === null || _m === void 0 ? void 0 : _m.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 2`
        },
        {
            'label': `log3`,
            'kind': (_o = window.monaco) === null || _o === void 0 ? void 0 : _o.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=3 &LogTxt=\`$1\`}`,
            'insertTextRules': (_p = window.monaco) === null || _p === void 0 ? void 0 : _p.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 3`
        },
        {
            'label': `log4`,
            'kind': (_q = window.monaco) === null || _q === void 0 ? void 0 : _q.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet &LogTxt=\`$1\`}`,
            'insertTextRules': (_r = window.monaco) === null || _r === void 0 ? void 0 : _r.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet`
        },
        {
            'label': `log5`,
            'kind': (_s = window.monaco) === null || _s === void 0 ? void 0 : _s.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=5 &LogTxt=\`$1\`}`,
            'insertTextRules': (_t = window.monaco) === null || _t === void 0 ? void 0 : _t.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 5`
        },
        {
            'label': `log6`,
            'kind': (_u = window.monaco) === null || _u === void 0 ? void 0 : _u.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=6 &LogTxt=\`$1\`}`,
            'insertTextRules': (_v = window.monaco) === null || _v === void 0 ? void 0 : _v.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 6`
        },
        {
            'label': `log7`,
            'kind': (_w = window.monaco) === null || _w === void 0 ? void 0 : _w.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=7 &LogTxt=\`$1\`}`,
            'insertTextRules': (_x = window.monaco) === null || _x === void 0 ? void 0 : _x.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 7`
        },
        {
            'label': `log8`,
            'kind': (_y = window.monaco) === null || _y === void 0 ? void 0 : _y.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=8 &LogTxt=\`$1\`}`,
            'insertTextRules': (_z = window.monaco) === null || _z === void 0 ? void 0 : _z.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 8`
        },
        {
            'label': `log9`,
            'kind': (_0 = window.monaco) === null || _0 === void 0 ? void 0 : _0.languages.CompletionItemKind.Snippet,
            'insertText': `{base/log.i\n        &LogLevel=9 &LogTxt=\`$1\`}`,
            'insertTextRules': (_1 = window.monaco) === null || _1 === void 0 ? void 0 : _1.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create log line with level 9`
        },
    ];
}
function getProgramStarts() {
    var _a, _b, _c, _d, _e, _f;
    return [{
            'label': `xmlprog2`,
            'kind': (_a = window.monaco) === null || _a === void 0 ? void 0 : _a.languages.CompletionItemKind.Snippet,
            'insertText': `{xml/incl/xmlprog2.i}

procedure eventMain:
    addToolbarButton('Back', 'Back', '', yes).
end procedure.`,
            'insertTextRules': (_b = window.monaco) === null || _b === void 0 ? void 0 : _b.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create XMLProg2 base program`
        },
        {
            'label': `xmlprog2web`,
            'kind': (_c = window.monaco) === null || _c === void 0 ? void 0 : _c.languages.CompletionItemKind.Snippet,
            'insertText': `{xml/incl/xmlprog2.i &webprog=on}

procedure eventMain:
    addToolbarButton('Back', 'Back', '', yes).
end procedure.`,
            'insertTextRules': (_d = window.monaco) === null || _d === void 0 ? void 0 : _d.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create XMLProg2 web base program`
        },
        {
            'label': `xmlprog3`,
            'kind': (_e = window.monaco) === null || _e === void 0 ? void 0 : _e.languages.CompletionItemKind.Snippet,
            //Important - this will interpret strings litterally therefore no "cleanup", do not change indentation, it will become ugly
            'insertText': `{xml/incl/xmlprog3.i}

function eventCheck {&VOID} (iEventCode as char, iSubWin as char, iRetVal as char):
  case iEventCode:
    when 'open' or when 'load' or when 'refresh' then $0.
    when 'back' then return2Parent('').
    when 'exit' then return2Module('util/logon').
    otherwise do:
        {xml/incl/xmlprog3dyne.i}
    end.
  end case.
  {&VOID_RET}
end function.`,
            'insertTextRules': (_f = window.monaco) === null || _f === void 0 ? void 0 : _f.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create XMLProg3 base program`
        },];
}
function getCustom() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return [
        {
            'label': `/picDoc`,
            'kind': (_a = window.monaco) === null || _a === void 0 ? void 0 : _a.languages.CompletionItemKind.Snippet,
            'insertText': `/**\r\n        * @meta \r\n        * $1\r\n        * @param\r\n        * @returns\r\n        */`,
            'insertTextRules': (_b = window.monaco) === null || _b === void 0 ? void 0 : _b.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': 'documentation'
        },
        {
            'label': `CMT`,
            'kind': (_c = window.monaco) === null || _c === void 0 ? void 0 : _c.languages.CompletionItemKind.Snippet,
            'insertText': `/*\n        $1 */`,
            'insertTextRules': (_d = window.monaco) === null || _d === void 0 ? void 0 : _d.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Comment`
        },
        {
            'label': `devErr`,
            'kind': (_e = window.monaco) === null || _e === void 0 ? void 0 : _e.languages.CompletionItemKind.Snippet,
            'insertText': `message\n        'DEVERROR:${(_g = (_f = window.PIC) === null || _f === void 0 ? void 0 : _f.user) !== null && _g !== void 0 ? _g : '$0'} ' $1.`,
            'insertTextRules': (_h = window.monaco) === null || _h === void 0 ? void 0 : _h.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create developer error msg line`
        },
        {
            'label': `FINALLY`,
            'kind': (_j = window.monaco) === null || _j === void 0 ? void 0 : _j.languages.CompletionItemKind.Snippet,
            'insertText': `finally:\n        $1\n        end finally.`,
            'insertTextRules': (_k = window.monaco) === null || _k === void 0 ? void 0 : _k.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Finally block`
        },
        {
            'label': `MES`,
            'kind': (_l = window.monaco) === null || _l === void 0 ? void 0 : _l.languages.CompletionItemKind.Snippet,
            'insertText': `message\n        $1.`,
            'insertTextRules': (_m = window.monaco) === null || _m === void 0 ? void 0 : _m.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Message`
        },
        {
            'label': `nn`,
            'kind': (_o = window.monaco) === null || _o === void 0 ? void 0 : _o.languages.CompletionItemKind.Snippet,
            'insertText': `(if $1 > '' then\n        $1 else '')`,
            'insertTextRules': (_p = window.monaco) === null || _p === void 0 ? void 0 : _p.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            'documentation': `Create NotNull code snippet`
        },
        // {
        //     'label': `startCMT`,
        //     'kind': window.monaco?.languages.CompletionItemKind.Snippet,
        //     'insertText': `/*------------------------------------------------------------------------\r\n        File : ${CurrentFilename}\r\n        Purpose : $1\r\n        Syntax : \r\n        Description : \r\n        Author(s) : ${user}\r\n        Created : ${ZonedDateTime}\r\n        Notes : \r\n        ----------------------------------------------------------------------*/`,
        //     'insertTextRules': window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        //     'documentation': `Create starting comment`
        // },
        // {
        //     'label': `xMsg`,
        //     'kind': window.monaco?.languages.CompletionItemKind.Snippet,
        //     'insertText': `run base/xmsg.p('${LogTag}',\n        ${PayerComp}, ${PayerUser}, '${To}', '${FromAddr}', '${FromName}', '${Subject}', '${Body}').`,
        //     'insertTextRules': window.monaco?.languages.CompletionItemInsertTextRule.InsertAsSnippet,
        //     'documentation': `Create xmsg line`
        // }
    ];
}
//# sourceMappingURL=ABLSuggestions.js.map